import React, { useEffect, useState, useCallback } from 'react';
import axios from 'axios';
import { getTrabajos } from '../services/Trabajos';
import Navbar from '../Navbar';
import Footer from '../Footer';
import Hero from '../Hero';
import Filtros from '../Filtros';
import TrabajoCard from '../TrabajosCard';

import '../../styles/Trabajos.css';
import '../../styles/index.css';
import '../../styles/main.css';

const Trabajos = () => {
  const [trabajos, setTrabajos] = useState([]);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [filtroColores] = useState({
    Peliculas: 'red',
    Caricaturas: 'green',
    Series: 'blue',
    Documentales: 'orange',
    Videojuegos: 'purple',
    Anime: 'skyblue'
  });

  // Verificar autenticación al cargar el componente
  useEffect(() => {
    const checkAuth = async () => {
        try {
            const response = await axios.get('/api/auth');
            setIsAuthenticated(response.data.isAuthenticated);
        } catch (error) {
            console.error('Error verificando autenticación:', error);
            setIsAuthenticated(false);
        }
    };
    checkAuth();
  }, []);

  // Modificar la función de filtrado
  const filtrarTrabajos = (filtros) => {
    const trabajos = document.querySelectorAll('.trabajo-item');
    let trabajosVisibles = 0;

    trabajos.forEach(trabajo => {
      const filtrosItem = trabajo.dataset.filtros ? trabajo.dataset.filtros.split(',') : [];
      const titulo = trabajo.dataset.titulo ? trabajo.dataset.titulo.toLowerCase() : '';
      
      // Filtro por categoría
      const cumpleCategoria = !filtros.categoria || filtrosItem.includes(filtros.categoria);
      
      // Filtro por experiencia (modificado para menor a mayor)
      const experienciaTrabajo = parseInt(trabajo.dataset.experiencia, 10);
      const experienciaFiltro = parseInt(filtros.experiencia, 10);
      const cumpleExperiencia = isNaN(experienciaFiltro) || experienciaTrabajo <= experienciaFiltro;
      
      // Filtro por modalidad
      const cumpleModalidad = !filtros.modalidad || trabajo.dataset.modalidad === filtros.modalidad;
      
      // Filtro por búsqueda
      const cumpleBusqueda = !searchTerm || titulo.includes(searchTerm.toLowerCase());

      if (cumpleCategoria && cumpleExperiencia && cumpleModalidad && cumpleBusqueda) {
        trabajo.style.display = 'flex';
        trabajosVisibles++;
      } else {
        trabajo.style.display = 'none';
      }
    });

    const mensajeNoResultados = document.querySelector('.no-results');
    if (mensajeNoResultados) {
      mensajeNoResultados.style.display = trabajosVisibles > 0 ? 'none' : 'block';
    }
  };

  // Función para manejar la búsqueda
  const handleSearch = (term) => {
    setSearchTerm(term);
    filtrarTrabajos({
      categoria: new URLSearchParams(window.location.search).get('categoria') || '',
      experiencia: new URLSearchParams(window.location.search).get('experiencia') || '',
      modalidad: new URLSearchParams(window.location.search).get('modalidad') || ''
    });
  };

  const cargarTrabajos = useCallback(async (filtros = {}) => {
    const data = await getTrabajos(filtros);
    setTrabajos(data);
    setTimeout(() => {
      const url = new URLSearchParams(window.location.search);
      filtrarTrabajos({
        categoria: url.get('categoria') || '',
        experiencia: url.get('experiencia') || '',
        modalidad: url.get('modalidad') || ''
      });
    }, 50);
  }, []);

  useEffect(() => {
    const experienciaSlider = document.getElementById('experiencia');
    const experienciaOutput = document.querySelector('output[for="experiencia"]');
    if (experienciaSlider && experienciaOutput) {
      const actualizarTexto = () => {
        experienciaOutput.textContent = `${experienciaSlider.value} años`;
      };
      experienciaSlider.addEventListener('input', actualizarTexto);
      experienciaSlider.dispatchEvent(new Event('input'));
      experienciaSlider.style.setProperty('--value', '0%');
      return () => experienciaSlider.removeEventListener('input', actualizarTexto);
    }
  }, []);

  useEffect(() => {
    const form = document.getElementById('filtros-form');
    if (!form) return;

    const handleSubmit = (e) => {
      e.preventDefault();
      const formData = new FormData(form);
      const categoria = formData.get('categoria');
      const experiencia = formData.get('experiencia');
      const modalidad = formData.get('modalidad');

      const params = new URLSearchParams();
      if (categoria) params.append('categoria', categoria);
      if (experiencia !== '0') params.append('experiencia', experiencia);
      if (modalidad) params.append('modalidad', modalidad);

      window.history.pushState({}, '', `/trabajos?${params.toString()}`);
      filtrarTrabajos({ categoria, experiencia, modalidad });
    };

    form.addEventListener('submit', handleSubmit);
    return () => form.removeEventListener('submit', handleSubmit);
  }, []);

  useEffect(() => {
    cargarTrabajos();
  }, [cargarTrabajos]);

  return (
    <>
      <Navbar isAuthenticated={isAuthenticated} />
      <Hero
        image="/images/HeroTrabajos.png"
        title="Hora de Descubrir <br> Nuevas Voces"
        description="Mira el catálogo de trabajos que DubbiDan tiene para ti. <br> Explora los proyectos de la comunidad"
      />
      <Filtros
        onFiltrar={cargarTrabajos}
        onSearch={handleSearch}
        categoriasDisponibles={
          trabajos.length > 0
            ? [...new Set(trabajos.flatMap((t) => t.filtros || []))]
            : []
        }
      />
      <div className="container my-5">
        {trabajos.length > 0 ? (
          trabajos.map((trabajo) => (
            <div
              key={trabajo._id}
              className="row mb-5 trabajo-item"
              data-filtros={(trabajo.filtros || []).join(',')}
              data-experiencia={trabajo.requisitos?.experiencia || 0}
              data-modalidad={trabajo.requisitos?.modalidad?.toLowerCase() || ''}
              data-titulo={trabajo.titulo.toLowerCase()}
            >
              <TrabajoCard trabajo={trabajo} filtroColores={filtroColores} />
            </div>
          ))
        ) : (
          <div className="row">
            <div className="col-12 text-center">
              <p className="text-muted">No se encontraron trabajos con los filtros seleccionados...</p>
              <a className="btn btn-primary" href="/trabajos">Mostrar todos</a>
            </div>
          </div>
        )}
      </div>
      <Footer />
    </>
  );
};

export default Trabajos;
